import { render, staticRenderFns } from "./schemaDetail.vue?vue&type=template&id=01940fdb&scoped=true"
import script from "./schemaDetail.vue?vue&type=script&lang=js"
export * from "./schemaDetail.vue?vue&type=script&lang=js"
import style0 from "./app.841a88aa.css?vue&type=style&index=0&id=01940fdb&prod&scoped=true&lang=css&external"
import style1 from "./schemaDetail.vue?vue&type=style&index=1&id=01940fdb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01940fdb",
  null
  
)

export default component.exports